/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// -----------------------------------------------------------------------------
// IMPORTS
// -----------------------------------------------------------------------------

// Internal dependencies
import SHARED_GLOBALS from '@configuration/tolino-GLOBALS';
import BUILDINFO from './../static/intermediates/configuration/buildinfo.json';
import PKG from './../package.json';

let url;
let CONFIG;
if (SHARED_GLOBALS.BUNDLER.BUILD_MODE === SHARED_GLOBALS.BUNDLER.BUILD_MODES.DEVELOPMENT) {
  // During development, we can just synchronously import the configuration,
  // because it has been created during development setup, e.g. while calling
  // yarn run develop:server, and is thus available at build time
  url = new URL('./../static/intermediates/configuration/config.json', import.meta.url);
} else {
  // For production builds, we need to fetch the configuration synchronously,
  // because the file will dynamically be created in the deployment phase and
  // is not available at build time, but only at run time.
  url = 'intermediates/configuration/config.json';
}
let xhr = new XMLHttpRequest();
xhr.open('GET', url, false);
xhr.send();
CONFIG = JSON.parse(xhr.responseText);


// -----------------------------------------------------------------------------
// CONFIGURATION
// -----------------------------------------------------------------------------

const GLOBALS = Object.freeze(Object.assign({}, SHARED_GLOBALS, {
  APPLICATION: {
    APP_ID: "samplereader",
    VERSION: PKG.version,
    NAME: "tolinoSampleReader"
  },

  BUILDINFO: BUILDINFO,

  DEPLOYMENT: CONFIG.DEPLOYMENT,

  LOCALE: {
    FALLBACK: 'de-DE',
    NAMESPACE: 'application',
    NAMESPACES: [
      'a11y',
      'application',
      'error'
    ],
    SUPPORTED: [
      'de-DE',
      'en-US',
      'es-ES',
      'fr-FR',
      'it-IT',
      'nl-NL'
    ]
  },

  MOREOPTIONS: [
    SHARED_GLOBALS.FEATURES.RX_TTS
  ],

  NETWORK: Object.assign({ },
    SHARED_GLOBALS.NETWORK,
    CONFIG.NETWORK
  ),

  THEME: {
    FALLBACK: 'theme-tolino-light'
  },

  TIMEOUT: {
    WINDOW_RESIZE_DEBOUNCE: 100 // time in ms; debounce of resize event handler
  },

  URL: {
    PARAMS: {
      LEGACY: {
        'backref': 'backref_url',
        'epuburl': 'epub_url',
        'lang': 'locale',
        'purchaseurl': 'purchase_url',
        'reseller': 'reseller_id',
        'resellers': 'purchase_urls'
      },
      VALID: [
        // public
        'backref_url',
        'end_of_book',
        'engine',
        'epub_url',
        'locale',
        'publication_id',
        'purchase_url',
        'purchase_urls',
        'reseller_id',
        'theme',

        // development/debugging
        'loglevel',
        'oauthsim'
      ]
    }
  }
}));


// -----------------------------------------------------------------------------
// EXPORTS
// -----------------------------------------------------------------------------

export default GLOBALS;
